import { useContext, useEffect, useMemo } from "react";
import apiClient from "./apiClient";
import { AppContext } from "../context/AppContext";

const isFormData = (v) => typeof FormData !== "undefined" && v instanceof FormData;

export const useApiClient = () => {
  const { token } = useContext(AppContext);

  useEffect(() => {
    const id = apiClient.interceptors.request.use((config) => {
      // ✅ Auth header
      if (token) config.headers.Authorization = `Bearer ${token}`;
      else delete config.headers.Authorization;

      // ✅ FormData Content-Type handling
      if (isFormData(config.data)) {
        // Let browser set Content-Type automatically for FormData
        delete config.headers['Content-Type'];
      }

      return config;
    });

    return () => apiClient.interceptors.request.eject(id);
  }, [token]);

  const ensureUrl = (url) => {
    const u = String(url ?? "").trim();
    if (!u || u === "undefined" || u === "null" || u.includes("undefined") || u.includes("null")) {
      throw new Error(`Blocked request: invalid url "${u}"`);
    }
    return u;
  };

  return useMemo(
    () => ({
      get: (url, params) => apiClient.get(ensureUrl(url), { params }),
      post: (url, data, config) => apiClient.post(ensureUrl(url), data, config),
      put: (url, data, config) => apiClient.put(ensureUrl(url), data, config),
      delete: (url, data, config) => apiClient.delete(ensureUrl(url), { data, ...(config || {}) }),
    }),
    []
  );
};



// import { useContext, useEffect, useMemo } from "react";
// import apiClient from "./apiClient";
// import { AppContext } from "../context/AppContext";

// export const useApiClient = () => {
//   const { token } = useContext(AppContext);

//   useEffect(() => {
//     const id = apiClient.interceptors.request.use((config) => {
//       if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//       } else {
//         delete config.headers.Authorization;
//       }
//       return config;
//     });

//     return () => apiClient.interceptors.request.eject(id);
//   }, [token]);

// const ensureUrl = (url) => {
//   if (!url || url === "undefined" || url === "null" || String(url).includes("undefined")) {
//     throw new Error(`Blocked request: invalid url "${url}"`);
//   }
//   return url;
// };

//   return useMemo(
//     () => ({
//       get: (url, params) => apiClient.get(url, { params }),
//       post: (url, data) => apiClient.post(url, data),
//       put: (url, data) => apiClient.put(url, data),
//       delete: (url, data) => apiClient.delete(url, { data }),
//     }),
//     []
//   );
// };
